module.exports = __webpack_public_path__ + "img/platform-analytics.7ae6dd64.svg";